import CircularIndeterminate from "components/utils/spinner/Spinner";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { rioNegroServices } from "recoilState/GlobalState";

const ServiceRoute = ({
    redirectProtectedRoute,
    servicioCod
}) => {
    const [loading, setLoading] = useState(true)
    const [service, setService] = useState()
    const services = useRecoilValue(rioNegroServices);

    const location = useLocation();

    useEffect(() => {
        
        if (services.length === 0) return;
        setLoading(true);
        if (!servicioCod) {
            setService(null)
            setLoading(false);
            return;
        };
        const currentService = services.find(service => service.servicioCod === servicioCod);
        console.log(currentService, services)

        if (!currentService || currentService?.servicioContratado === 'N' || currentService?.servicioAutorizado === 'N' || currentService?.servicioPermiso === 'N') {
            setService(null)
            setLoading(false);
            return;
        }
        setService(currentService);
        setLoading(false);
    }, [servicioCod, services]);


    if (loading) return <CircularIndeterminate />
    if (service) return <Outlet context={{ service }} />;
    return <Navigate to={redirectProtectedRoute} state={{ from: location }} replace />;
}

export default ServiceRoute;

export const useService = () => {
    return useOutletContext()
}

/**
 * Si el usuario puede MODIFICAR en este servicio, o solo mirarlo.
 *
 * `servicioPermiso` viene con el servicio y vale 'E' cuando hay permiso de edicion. Un rol de
 * Visualizador llega con otro valor, asi que todo lo que escribe —crear, modificar, eliminar—
 * tiene que quedar deshabilitado.
 *
 * El back ya lo valida, pero rechazarlo recien en el submit es el peor momento: la persona
 * llena el formulario entero y recien ahi se entera de que no podia. El boton apagado lo dice
 * antes de empezar.
 *
 * Como funcion y no como hook para poder usarla dentro del JSX de cada boton sin sumar una
 * variable en cada vista, y para que el `service` del que depende quede a la vista en la
 * llamada.
 */
export const puedeEditarServicio = (service) => service?.servicioPermiso === "E";
